import{m as e}from"./chunk-HBP5N4FR.js";e();var n=()=>Boolean((window==null?void 0:window.isOpera)&&(window==null?void 0:window.elrond));export{n as a};
//# sourceMappingURL=chunk-H2CTTA7B.js.map
